import { Container } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import PermissionsList from '../../../Component/Application/Permissions/PermissionsList';
import { useTranslation } from 'react-i18next';

const PermissionsManagement = () => {
  const { t } = useTranslation();
  return (
    <div className="page-body">
      <Breadcrumbs mainTitle={t('Gestión de Permisos')} parent={t('Administración')} />
      <Container fluid>
        <PermissionsList />
      </Container>
    </div>
  );
};

export default PermissionsManagement;

